import { render, staticRenderFns } from "./UploadFz.vue?vue&type=template&id=04d653f6"
import script from "./UploadFz.vue?vue&type=script&lang=js"
export * from "./UploadFz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d653f6')) {
      api.createRecord('04d653f6', component.options)
    } else {
      api.reload('04d653f6', component.options)
    }
    module.hot.accept("./UploadFz.vue?vue&type=template&id=04d653f6", function () {
      api.rerender('04d653f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Generator/components/Upload/UploadFz.vue"
export default component.exports